<template>
  <div class="customizer-header">
    <div class="close" @click="resetCustomizer">
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.41425 7.667L13.7072 2.374C14.0982 1.983 14.0982 1.351 13.7072 0.959998C13.3162 0.568998 12.6842 0.568998 12.2933 0.959998L7.00025 6.253L1.70725 0.959998C1.31625 0.568998 0.68425 0.568998 0.29325 0.959998C-0.09775 1.351 -0.09775 1.983 0.29325 2.374L5.58625 7.667L0.29325 12.96C-0.09775 13.351 -0.09775 13.983 0.29325 14.374C0.48825 14.569 0.74425 14.667 1.00025 14.667C1.25625 14.667 1.51225 14.569 1.70725 14.374L7.00025 9.081L12.2933 14.374C12.4882 14.569 12.7443 14.667 13.0002 14.667C13.2562 14.667 13.5122 14.569 13.7072 14.374C14.0982 13.983 14.0982 13.351 13.7072 12.96L8.41425 7.667Z"
              fill="#969696"/>
      </svg>
    </div>
    <div class="step" v-if="getStep">
      <span class="number">{{ getStep.step }}</span>
      <span class="title"> {{ getStep.instruction }}</span>
    </div>
    <div class="logo">
      <svg width="29" height="34" viewBox="0 0 29 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.119 14.676C12.8759 14.676 11.7769 14.9665 10.84 15.4568C9.90312 15.947 9.00229 16.8185 8.4798 17.69C7.95731 18.5616 7.70508 19.2697 7.70508 20.3591C7.70508 21.9932 8.2636 23.4638 9.39865 24.4443C10.5157 25.4248 12.2453 25.915 14.065 25.8242C14.1371 25.8242 14.1911 25.8242 14.2632 25.8061C17.4882 25.6608 19.7223 24.4443 21.8663 22.8102C21.596 22.211 21.2717 21.6845 20.8573 21.2487C19.9385 22.0113 18.8214 22.6105 17.8485 22.9736C16.5513 23.4638 15.6144 23.5546 14.4433 23.2641C13.2723 22.9736 12.7498 22.5742 12.1732 21.8842C11.6147 21.1761 11.4526 20.4862 11.6688 19.5965C11.867 18.7613 12.4255 18.1258 13.1642 17.7445C13.2002 17.7263 13.2542 17.7082 13.2903 17.69C13.3263 17.6719 13.3623 17.6537 13.3984 17.6356C13.4164 17.6356 13.4164 17.6356 13.4344 17.6174C16.0829 16.4372 19.5601 17.9987 22.2987 21.3395C24.803 24.408 24.3526 29.9821 24.2625 33.5226C25.7399 33.5226 27.1452 33.5226 29.0009 33.5226C29.0009 21.8661 22.5689 14.676 14.119 14.676Z"
            fill="#3C3C3C"/>
        <path
            d="M19.902 0.477539C17.5418 0.477539 11.6503 0.477539 8.85775 0.477539H0.822266V7.23181V8.01255C0.822266 14.8758 0.822266 23.9904 0.822266 33.4863C3.48875 33.4863 4.98414 33.4863 6.29937 33.4863V4.7262C6.29937 4.7262 15.8122 4.7262 16.4428 4.7262C21.1452 4.7262 24.6044 8.75697 24.6044 13.0783C24.6044 14.1858 24.4062 15.366 24.0099 16.5099C24.6765 16.8185 25.5233 17.218 26.4421 17.6537C27.9736 15.1481 28.7843 12.3701 28.7843 9.70112C28.7843 4.07256 24.4963 0.477539 19.902 0.477539Z"
            fill="#3C3C3C"/>
      </svg>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters } from "vuex";

export default {
  name: "Header",
  computed: {
    ...mapGetters({
      getStep: 'customizer/getStep'
    }),
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Escape') {
        this.resetCustomizer()
      }
    });
  },
  methods: {
    ...mapActions({
      resetCustomizer: 'customizer/resetCustomizer'
    })
  }
}
</script>

<style scoped lang="scss">
.customizer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px 15px 15px;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  width: 100%;

  @media (max-width:480px) {
    padding: 15px 0;
  }

  .close {
    width: 50px;
    height: 47px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      path {
        transition: all .2s;
      }
    }

    &:hover {
      svg {
        path {
          fill: #333
        }
      }
    }
  }

  .step {
    color: #969696;

    .number {
      width: 30px;
      height: 30px;
      border-radius: 20px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background: #F9F9F9;
      margin: 0 10px 0 0;
    }
  }
}
</style>
